<template>
  <div id="contenedor-main-infraestructura-configuracion-tipos-infraestructura">
    <tool-bar
      v-on:nuevaCaracteristicaSubtipoInfraestructura="agregarNuevaCaracteristicaSubtipo">
    </tool-bar>
    <v-container
      fluid>
      <v-card
        flat>
        <v-card-text>
          <v-row>
            <custom-autocomplete
              cols="4"
              v-model="idSubtipoInfraestructura"
              label="Seleccionar Subtipo Infraestructura"
              :items="this.getSubtiposInfraestructura"
              item-text="descripcion"
              item-value="id"
              :rules="[mixReglas.requerido]">
            </custom-autocomplete>
          </v-row>
          <listado
            :listadoCaracteristciasSubtipoInfraestructura="getCaracteristicasSubtipo">
          </listado>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- Ventana Agregar Tipo Infraestructura -->
    <v-dialog
      v-if="mostrarVentanaAgregarCaracteristicaSubtipoInfraestructura"
      v-model="mostrarVentanaAgregarCaracteristicaSubtipoInfraestructura"
      persistent
      width="600">
      <agregar-caracteristica-subtipo-infraestructura
      :idSubtipoInfraestructura="this.idSubtipoInfraestructura"
      v-on:cerrar="cerrarVentana">
      </agregar-caracteristica-subtipo-infraestructura>
    </v-dialog>
    <!-- Ventana Editar Tipo Infraestructura -->
    <v-dialog
      v-if="esteCaracteristicaSubtipoInfraestructura"
      v-model="mostrarVentanaEditarCaracteristicaSubtipoInfraestructura"
      scrollable
      persistent
      width="600">
      <editar-caracteristica-subtipo-infraestructura
      :subtipoInfraestructuraCaractetristicaEditar="esteCaracteristicaSubtipoInfraestructura"
      v-on:cerrar="cerrarVentana">
      </editar-caracteristica-subtipo-infraestructura>
    </v-dialog>
    <!-- Ventana Eliminar Tipo Infraestructura -->
    <v-dialog
      v-if="esteCaracteristicaSubtipoInfraestructura"
      v-model="mostrarVentanaEiminarCaracteristicaSubtipoInfraestructura"
      scrollable
      persistent
      width="400">
      <eliminar-caracteristica-subtipo-infraestructura
      :caracteristicaSubtipoInfraestructuraEliminar="esteCaracteristicaSubtipoInfraestructura"
      v-on:cerrar="cerrarVentana">
      </eliminar-caracteristica-subtipo-infraestructura>
    </v-dialog>
  </div>
</template>

<script>
import CATALOGO_INFRAESTRUCTURA_SUBTIPO_CARACTERISTICAS from '@/graphql/querys/administracion/catalogos/infraestructurasubtipocaracteristicas/catalogoInfraestructuraSubtipoCaracteristicas.gql';
import CATALOGO_INFRAESTRUCTURA_SUBTIPOS from '@/graphql/querys/administracion/catalogos/infraestructurasubtipos/catalogoInfraestructuraSubtipos.gql';
import CustomAutocomplete from '@/components/inputs/Autocomplete.vue';
import ToolBar from './ToolBar.vue';
// import CustomButton from '@/components/buttons/Button.vue';
import AgregarCaracteristicaSubtipoInfraestructura from '@/components/administracion/infraestructura/configuracion/caracteristicassubtipoinfraestructura/Nuevo.vue';
import EditarCaracteristicaSubtipoInfraestructura from '@/components/administracion/infraestructura/configuracion/caracteristicassubtipoinfraestructura/Editar.vue';
import EliminarCaracteristicaSubtipoInfraestructura from '@/components/administracion/infraestructura/configuracion/caracteristicassubtipoinfraestructura/Eliminar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'MainInfraestructuraConfiguracionTiposInfraestructura',
  components: {
    ToolBar,
    CustomAutocomplete,
    AgregarCaracteristicaSubtipoInfraestructura,
    EditarCaracteristicaSubtipoInfraestructura,
    EliminarCaracteristicaSubtipoInfraestructura,
    Listado,
  },
  data() {
    return {
      idSubtipoInfraestructura: '',
      mostrarVentanaAgregarCaracteristicaSubtipoInfraestructura: false,
      mostrarVentanaEditarCaracteristicaSubtipoInfraestructura: false,
      mostrarVentanaEiminarCaracteristicaSubtipoInfraestructura: false,
      esteCaracteristicaSubtipoInfraestructura: null,
    };
  },
  apollo: {
    catalogoInfraestructuraSubtipos: {
      query: CATALOGO_INFRAESTRUCTURA_SUBTIPOS,
    },
    catalogoInfraestructuraSubtipoCaracteristicas: {
      query: CATALOGO_INFRAESTRUCTURA_SUBTIPO_CARACTERISTICAS,
      variables() {
        return {
          idSubtipoInfraestructura: this.idSubtipoInfraestructura ? this.idSubtipoInfraestructura : '',
        };
      },
    },
  },
  mounted() {
    eventBus.$on('editar-caracteristica-subtipo-infraestructura', (caracteristicaSubtipoInfraestructura) => {
      this.mostrarVentanaEditarCaracteristicaSubtipoInfraestructura = true;
      this.esteCaracteristicaSubtipoInfraestructura = caracteristicaSubtipoInfraestructura;
    });
    eventBus.$on('eliminar-caracteristica-subtipo-infraestructura', (caracteristicaSubtipoInfraestructura) => {
      this.mostrarVentanaEiminarCaracteristicaSubtipoInfraestructura = true;
      this.esteCaracteristicaSubtipoInfraestructura = caracteristicaSubtipoInfraestructura;
    });
  },
  methods: {
    cerrarVentana() {
      this.mostrarVentanaAgregarCaracteristicaSubtipoInfraestructura = false;
      this.mostrarVentanaEditarCaracteristicaSubtipoInfraestructura = false;
      this.mostrarVentanaEiminarCaracteristicaSubtipoInfraestructura = false;
      this.esteCaracteristicaSubtipoInfraestructura = null;
    },
    agregarNuevaCaracteristicaSubtipo() {
      this.mostrarVentanaAgregarCaracteristicaSubtipoInfraestructura = true;
    },
  },
  computed: {
    getSubtiposInfraestructura() {
      if (!this.catalogoInfraestructuraSubtipos) return [];
      return this.catalogoInfraestructuraSubtipos;
    },
    getCaracteristicasSubtipo() {
      if (!this.catalogoInfraestructuraSubtipoCaracteristicas) return [];
      return this.catalogoInfraestructuraSubtipoCaracteristicas;
    },
  },
};
</script>

<style lang="scss">

</style>
